<template>
  <div>
    <span v-if="containerId" class="btn" @click="setup"> <i class="fa-light fa-file-signature"></i> {{ text }} </span>
    <a
      v-if="!containerId"
      class="btn"
      :class="{ green: allGivableGiven, red: noneGivableGiven, orange: someGivableGiven }"
      :href="url"
      onclick="javascript:Loader.show();"
    >
      <i class="fa-light fa-file-signature"></i> {{ text }}
    </a>
  </div>
</template>

<script>
import axios from 'axios';
import spinner from '../spinner';

export default {
  name: 'gdpractivator',
  props: [
    'containerId',
    'consents_given',
    'full_name',
    'model',
    'post_url',
    'report_url',
    'report_check_url',
    'subject_type',
    'subject_id',
    'ptext',
    'url',
    'preview_url',
    'firstname',
    'surname',
  ],
  computed: {
    allGivableGiven() {
      return this.consents_given == 'all';
    },
    noneGivableGiven() {
      return this.consents_given == 'none';
    },
    someGivableGiven() {
      return this.consents_given == 'some';
    },
    text() {
      return this.ptext || window.i18nJS['attiva'];
    },
  },
  methods: {
    setup: function () {
      var vueComp = document.createElement('div');
      vueComp.className = 'vue-container';
      var gdprconsent = document.createElement('gdprconsent');
      gdprconsent.setAttribute(':model', JSON.stringify(this.model));
      gdprconsent.setAttribute(':post_url', "'" + this.post_url + "'");
      gdprconsent.setAttribute(':preview_url', "'" + this.preview_url + "'");
      gdprconsent.setAttribute(':report_url', "'" + this.report_url + "'");
      gdprconsent.setAttribute(':report_check_url', "'" + this.report_check_url + "'");
      gdprconsent.setAttribute(':full_name', "'" + this.full_name.replace(/'/g, "\\'") + "'");
      gdprconsent.setAttribute(':subject_type', "'" + this.subject_type + "'");
      gdprconsent.setAttribute(':subject_id', "'" + this.subject_id + "'");
      gdprconsent.setAttribute(':firstname', "'" + this.firstname + "'");
      gdprconsent.setAttribute(':surname', "'" + this.surname + "'");
      gdprconsent.setAttribute(':show-only-save-button', "'" + true + "'");

      vueComp.appendChild(gdprconsent);
      $('#' + this.containerId).html(vueComp);
      window.updateVueInstances();
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  border-radius: 50px;
  &.green {
    border-color: green;
  }
  &.red {
    border-color: red;
  }
  &.orange {
    border-color: orange;
  }
}
</style>
